module.exports = __webpack_public_path__ + "static/media/WorldGalleryBg-sm.c84f74e2.jpg";